import { useMutation } from '@tanstack/react-query';

async function searchNewPlayer({
  leagueSessionID,
  searchWord,
}: {
  leagueSessionID: string;
  searchWord: string;
}) {
  const response = await fetch(`/api/v1/leagues/gameDay/header/searchNewPlayer`, {
    method: 'POST',
    body: JSON.stringify({
      leagueSessionID: leagueSessionID,
      searchWord: searchWord,
    }),
  });
  const responseData = await response.json();

  return responseData.data;
}

async function addNewPlayer({
  leagueSessionID,
  userID,
  matchDateID,
  fullName,
}: {
  leagueSessionID: string;
  userID: string;
  matchDateID: string;
  fullName: string;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/addPlayer`, {
      method: 'POST',
      body: JSON.stringify({
        leagueSessionID: leagueSessionID,
        userID: userID,
        matchDateID: matchDateID,
        fullName: fullName,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    return { message: 'An error occurred while trying to add the new player.' };
  }
}

export const useSearchNewPlayer = () => useMutation(searchNewPlayer);
export const useAddNewPlayer = () => useMutation(addNewPlayer);
